// ui-manager-it.js
// Gestione dell'interfaccia utente — versione italiana

/**
 * Crea un'icona per un pulsante
 */
export function createIcon(imageName) {
    const img = document.createElement('img');
    img.src = `./icones/${imageName}.svg`;
    img.alt = imageName;
    img.className = 'button-icon';
    img.style.pointerEvents = 'none';
    
    img.onerror = () => {
      console.error(`Impossibile caricare l'icona: ${imageName}.svg`);
      const buttonToRestore = img.parentElement;
      if (buttonToRestore && buttonToRestore.title) {
        buttonToRestore.textContent = buttonToRestore.title;
      }
    };
    
    return img;
  }
  
  /**
   * Remplace le texte des boutons par des icônes.
   * Utilise l'attribut data-icon si présent,
   * sinon repli sur le texte (carte FR + IT).
   */
  export function replaceButtonTextsWithIcons() {
    // Correspondance texte → icône (français ET italien)
    const buttonIconMap = {
      // Français (compatibilité)
      'Enregistrer': 'microphone',
      'Stop': 'stop3',
      'Supprimer': 'trash2',
      '↑': 'up',
      '↓': 'down',
      'Télécharger': 'download',
      'Découper ici': 'cut2',
      'Combiner': 'combine2',
      'Combiner et Normaliser': 'normalize',
      'Importer un son': 'upload',
      'Enregistrement en cours': 'recording',
      'Sélectionner depuis la bibliothèque': 'cloud',
      'Importer depuis mon ordinateur': 'pc',
      'Tout télécharger': 'toutTelecharger',
      // Italien
      'Registra': 'microphone',
      'Stop': 'stop3',
      'Elimina': 'trash2',
      'Scarica': 'download',
      'Taglia qui': 'cut2',
      'Combina': 'combine2',
      'Combina e Normalizza': 'normalize',
      'Importa un suono': 'upload',
      'Registrazione in corso': 'recording',
      'Seleziona dalla libreria': 'cloud',
      'Importa dal computer': 'pc',
      'Scarica tutto': 'toutTelecharger',
    };
  
    const buttons = document.querySelectorAll('button');
  
    buttons.forEach(button => {
      // Priorité à data-icon
      const dataIcon = button.getAttribute('data-icon');
      if (dataIcon) {
        button.textContent = '';
        button.appendChild(createIcon(dataIcon));
        // title déjà posé dans le HTML
        return;
      }
  
      // Repli sur le texte
      const buttonText = button.textContent.trim();
      if (buttonIconMap[buttonText]) {
        button.textContent = '';
        button.appendChild(createIcon(buttonIconMap[buttonText]));
        button.title = buttonText;
      }
    });
  }
  
  /**
   * Initialise l'observateur pour les nouveaux boutons
   */
  export function initButtonObserver() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const buttons = node.getElementsByTagName('button');
            if (buttons.length > 0) {
              replaceButtonTextsWithIcons();
            }
          }
        });
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  /**
   * Crée la barre de progression
   */
  export function createProgressBar() {
    const progressContainer = document.createElement('div');
    const progressBar = document.createElement('div');
    progressContainer.className = 'progress-container';
    progressBar.className = 'progress-bar';
    progressContainer.appendChild(progressBar);
  
    function updateProgressBar(percentage) {
      progressBar.style.width = percentage + '%';
      if (percentage > 0) {
        progressContainer.classList.add('active');
      } else {
        progressContainer.classList.remove('active');
      }
    }
  
    return { progressContainer, progressBar, updateProgressBar };
  }
  
  /**
   * Configure le mode Pro
   */
  export function setupProMode(config) {
    const {
      proModeToggle,
      importButton,
      normalizeButton,
      importFromComputerButton,
      importFromLibraryButton,
      importOptions
    } = config;
  
    let isProMode = false;
  
    proModeToggle.addEventListener('click', () => {
      isProMode = !isProMode;
      proModeToggle.classList.toggle('pro-mode-active', isProMode);
      proModeToggle.textContent = isProMode ? '➖' : '➕';
      
      importButton.classList.toggle('visible', isProMode);
      importButton.disabled = !isProMode;
      
      normalizeButton.style.display = isProMode ? 'inline-block' : 'none';
      normalizeButton.classList.toggle('visible', isProMode);
  
      importFromComputerButton.disabled = !isProMode;
      importFromLibraryButton.disabled = !isProMode;
      
      if (!isProMode && importOptions.style.display !== 'none') {
        importOptions.style.display = 'none';
      }
    });
  
    return {
      isProMode: () => isProMode
    };
  }
  
  /**
   * Crea il contenitore dei clip combinati
   */
  export function createCombinedClipsContainer() {
    const combinedClipsContainer = document.createElement('div');
    combinedClipsContainer.className = 'combined-clips';
    const combinedTitle = document.createElement('h3');
    combinedTitle.textContent = 'Clip Combinati';
    combinedTitle.style.marginTop = '20px';
    combinedClipsContainer.appendChild(combinedTitle);
    return combinedClipsContainer;
  }
  
  /**
   * Crea il pulsante "Scarica tutto"
   */
  export function createDownloadAllButton(onClickCallback) {
    const downloadAllButton = document.createElement('button');
    downloadAllButton.textContent = 'Scarica tutto';
    downloadAllButton.className = 'download-all';
  
    const downloadAllContainer = document.createElement('div');
    downloadAllContainer.className = 'download-all-container';
    downloadAllContainer.appendChild(downloadAllButton);
  
    downloadAllButton.addEventListener('click', onClickCallback);
  
    return downloadAllContainer;
  }
  
  /**
   * Affiche un compte à rebours avant l'enregistrement
   */
  export function startCountdown(onComplete) {
    return new Promise((resolve) => {
      let count = 3;
      const countdownEl = document.createElement('div');
      countdownEl.className = 'countdown';
      document.body.appendChild(countdownEl);
      
      const countInterval = setInterval(() => {
        if (count > 0) {
          countdownEl.textContent = count;
          count--;
        } else {
          clearInterval(countInterval);
          countdownEl.remove();
          if (onComplete) onComplete();
          resolve();
        }
      }, 1000);
      
      countdownEl.textContent = count;
    });
  }
  
  /**
   * Ajoute les styles CSS pour les icônes
   */
  export function addIconStyles() {
    const iconStyles = document.createElement('style');
    iconStyles.textContent = `
      button {
        padding: 20px;
      }
  
      button > * {
        display: inline-flex;
        align-items: center;
        gap: 1rem;
      }
  
      .button-icon {
        width: 40px;
        height: 40px;
        pointer-events: none;
      }
    `;
    document.head.appendChild(iconStyles);
  }
  
  // Ajouter les styles au chargement du module
  addIconStyles();